import { Button, Checkbox, FormControlLabel, Typography } from "@mui/material";

interface ContrlProps {}

export default function Controls({}: ContrlProps) {
  return (
    <div className="controls">
      <div>
        <Typography variant="h5" style={{ paddingBottom: 20 }}>
          Others Topics
        </Typography>
        <Typography style={{ paddingBottom: 10, textAlign: "left" }}>
          Hard at Work Making Magic Happen! Welcome to join{" "}
          <a href="https://discord.gg/TfwZ3hH2D2">our discord</a> to know when I
          finish this feature.
        </Typography>
      </div>
    </div>
  );
}
